var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('subMenu',{key:"subMenu",attrs:{"activeTab":_vm.activeTab,"menuList":_vm.menuList},on:{"handItem":_vm.handItem}}),_c('partner',{key:"partner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }